import { withPending, withRejected, withFulFilled } from './commons';

import {
  SEND_RECOVER_PASSWORD_EMAIL,
  PASSWORD_UPDATED,
  TOKEN_VALIDATION,
  RESET_EMAIL,
} from '../actions/recoverPassword';

// initial state
const INITIAL_STATE = {
  running: false,
  error: null,
  emailSent: false,
  passwordUpdated: false,
  isTokenValid: false,
};

// executer
const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  // create
  case withPending(SEND_RECOVER_PASSWORD_EMAIL):
    return { ...state, running: true };
    // reject
  case withRejected(SEND_RECOVER_PASSWORD_EMAIL):
    return { ...state, running: false, error: action.payload };
    // success
  case withFulFilled(SEND_RECOVER_PASSWORD_EMAIL):
    return { ...state, emailSent: true, running: false };
    // create
  case withPending(PASSWORD_UPDATED):
    return { ...state, running: true };
    // reject
  case withRejected(PASSWORD_UPDATED):
    return { ...state, running: false, error: action.payload };
    // success
  case withFulFilled(PASSWORD_UPDATED):
    return { ...state, passwordUpdated: true, running: false };
    // crete
  case withPending(TOKEN_VALIDATION):
    return { ...state, running: true };
    // reject
  case withRejected(TOKEN_VALIDATION):
    return { ...state, running: false, error: action.payload, isTokenValid: false };
    // success
  case withFulFilled(TOKEN_VALIDATION):
    return { ...state, running: false, isTokenValid: true };
  case RESET_EMAIL:
    return { ...state, running: false, emailSent: false };

  default:
    return state;
  }
};

export default execute;
